import React, { Component } from 'react';
import { findDOMNode } from "react-dom";
import Success from "../../elements/Success";
import Loader from "../../elements/Loader";
import Errors from "../../elements/Errors";
import Button from "../../elements/Button";
import FancyInput from "../../elements/FancyInput";
import axios from "axios/index";
import globals from "../../globals";
import animations from "./animations";
import HoneyPot from "../../elements/HoneyPot";
import Heading from "../../elements/Heading";
import { sha256 } from 'js-sha256';

class RegisterInterestForm extends Component {

	constructor(props) {
		super(props);

		this.honeypot = 'dob';

		this.state = {
			first_name: '',
			last_name: '',
			mobile: '',
			company: '',
			email: '',
			[this.honeypot]: '', //honeypot
			errors: [],
			animateSuccess: false,
            product: props.product
		};
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
	    if (prevProps.product !== this.state.product) {
	        this.setState({product: this.props.product});
        }
    }

    handleInputChange(event) {
		const target = event.target;
		this.setState({
			[target.name]: target.value
		});
	}

	handleSubmit(event) {
		event.preventDefault();
		this.reset();
		animations.showLoader(this);

		setTimeout(() => {
			axios.post('/api/submit-register-interest-form', this.state)
				.then(() => {
                    globals.pushHJEvent(this.props.hjEvent);
                    globals.pushGA4Events(window.location.pathname.includes('unified-communications') ? 'unifiedCommunicationsFormSubmit' :'banterWorkFromHomeFormSubmit',
                        {
                            eventInfo: {
                                formName: window.location.pathname.includes('unified-communications') ? 'Unified Communication form' : 'Work from home Banter form',
                                hashedFirstName: sha256(this.state.first_name),
                                hashedLastName: sha256(this.state.last_name),
                                hashedEmail: sha256(this.state.email),
                                hashedPhoneNumber: sha256(this.state.mobile),
                                pageCategory: 'Business',
                            }
                        })
					this.showSuccess();
				})
				.catch(response => {
					this.reset();
					if (response.response.status === 422) {
						this.processValidation(response.response);
					} else {
						this.handleError(response);
					}
				});
		}, 2000);
	}

	showSuccess() {
		this.setState({
			animateSuccess: true
		}, () => {
			animations.hideLoader(this);
		});
	}

	processValidation(response) {
		let FormNode = findDOMNode(this),
			errors = response.data.errors;

		for (let key in errors) {
			if (key === this.honeypot) {
				// do nothing
			} else {
			    let node = FormNode.querySelector('.input-' + key + ' .graphic--nao');
			    if (node) {
                    node.style.stroke = 'red';
                }
			}

			this.updateErrors(errors[key][0]);
		}

		animations.showErrors(this);
	}

	updateErrors(newError) {
		this.setState(prevState => ({
			errors: [...prevState.errors, newError]
		}));
	}

	handleError(response) {
		this.updateErrors(globals.getGenericErrorMsg());
		animations.showErrors(this);
		globals.handleError(response.message, response);
	}

	reset() {
		this.setState({
			errors: []
		});
		animations.reset(this);
	}

	render() {
		return (
			<div className={`register-interest-form white-bg-form ${this.props.reverse ? 'reverse' : ''}`}>
				<div className="register-interest-anchor" />
				<Heading title={this.props.title} subTitle={this.props.subTitle} />
				<div className="row form-outer">
					<div className="col-md-8 col-md-offset-2 col-xs-12 form-inner">
						<form onSubmit={this.handleSubmit.bind(this)}>
							<div className="row form-row">
								<div className="col-sm-6 name-fields">
									<FancyInput name="first_name" maxLength="50" label="First Name" value={this.state.first_name} handleChange={this.handleInputChange.bind(this)} />
									<FancyInput name="last_name" maxLength="50" label="Last Name" value={this.state.last_name} handleChange={this.handleInputChange.bind(this)} />
								</div>
								<div className="col-sm-6">
									<FancyInput name="mobile" type="tel" maxLength="20" label="Mobile Number" value={this.state.mobile} handleChange={this.handleInputChange.bind(this)} />
								</div>
							</div>
							<HoneyPot nameField={this.honeypot} nameValue={this.state[this.honeypot]} handleChange={this.handleInputChange.bind(this)} />
							<div className="row form-row">
								<div className="col-sm-6">
									<FancyInput name="email" type="email" maxLength="50" label="Email" value={this.state.email} handleChange={this.handleInputChange.bind(this)} />
								</div>
								<div className="col-sm-6">
									<FancyInput name="company" maxLength="50" label="Company (optional)" value={this.state.company} handleChange={this.handleInputChange.bind(this)} />
								</div>
							</div>
							<Errors errors={this.state.errors} />
							<div className="row centered form-row button-row">
								<div className="col-xs-12">
									<Button
										action={event => this.handleSubmit(event)}
										image="/images/btn-submit-darkgreen.svg"
										alt="Lets get started"
									/>
								</div>
							</div>
						</form>
                        <Success animate={this.state.animateSuccess}>
                            <p>Thanks for registering your interest. We will be in touch shortly.</p>
                        </Success>
                        <Loader whiteBg={true} />
					</div>
				</div>
			</div>
		);
	}

}

export default RegisterInterestForm;


// WEBPACK FOOTER //
// ./resources/assets/js/forms/RegisterInterestForm/RegisterInterestForm.js